<template>
<div>
  <transition name="fade">
    <div v-if="!dataLoaded" class="rainbow-spinner">
      <md-progress-spinner class="spinner" :md-diameter="40" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
    </div>
  </transition>
  <transition name="fade">
    <div class="md-layout" v-if="dataLoaded">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-warning">
            <div class="card-text">
              <h4 class="title">Rainbow - Blogs</h4>
              <p class="category">View and manage blogs</p>
            </div>
            <div class="pull-right">
              <md-button
                @click="openNewBlogForm()"
                class="md-primary md-just-icon md-round mt-10"
              >
                <md-icon>add</md-icon>
              </md-button>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-20">
                <md-field>
                  <label>Search by name</label>
                  <md-input
                    v-model="searchQuery"
                    type="search"
                    clearable
                  ></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-20">
                <md-field>
                  <label for="sortBy">Status</label>
                  <md-select v-model="filters.status" name="status">
                    <md-option value="all">All</md-option>
                    <md-option value="active">Active</md-option>
                    <md-option value="inactive">Inactive</md-option>
                    <md-option value="featured">Featured</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-20">
                <md-field>
                  <label for="sortBy">Sort by</label>
                  <md-select v-model="filters.sortBy" name="sortBy" id="sortBy">
                    <md-option value="arranged">Arranged</md-option>
                    <md-option value="name">Blog Name</md-option>
                    <md-option value="createdAt">Date Created</md-option>
                    <md-option value="publishedAt">Date Published</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-20">
                <md-field class="md-size-20">
                  <label for="sortBy">Sort Order</label>
                  <md-select
                    v-model="filters.sortOrder"
                    name="sortOrder"
                    id="sortOrder"
                  >
                    <md-option value="asc">Ascending</md-option>
                    <md-option value="desc">Descending</md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-20">
                <md-field>
                  <label for="perPage">Per page</label>
                  <md-select v-model="filters.perPage" name="perPage">
                    <md-option
                      v-for="item in perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                      {{ item }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-size-50 mx-auto" style="height:5px;">
                <md-progress-bar v-if="searching" class="md-accent" md-mode="query"></md-progress-bar>
              </div>
            </div>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <div class="">
              <p class="card-category">
                Showing {{ total > 0 ? from + 1 : 0 }} to {{ to }} of {{ total }} blogs
              </p>
            </div>
            <pagination
              class="pagination-no-border pagination-primary"
              v-model="filters.currentPage"
              :per-page="filters.perPage"
              :total="total"
            >
            </pagination>
          </md-card-actions>
        </md-card>
      </div>

      <!-- Blog cards -->
      <div
        class="md-layout-item md-size-25"
        v-for="blog in queriedData"
        :key="blog.Id"
      >
        <md-card
          class="md-card-product"
          @mouseleave.native="onMouseLeave"
          :data-count="hoverCount"
        >
          <md-card-header
            @mouseenter.native="onMouseOver"
            :data-header-animation="headerAnimation"
            :class="[
              { hovered: imgHovered },
              { hinge: headerDown },
              { fadeInDown: fixedHeader }
            ]"
            class="md-card-header-image animated"
          >
            <img
              v-if="blog.CoverPhoto != null"
              class="img"
              :src="blog.CoverPhoto.Thumbnail"
            />
            <img v-else class="img" src="/img/image_placeholder.jpg" />
          </md-card-header>

          <md-card-content>
            <div
              class="md-card-action-buttons text-center"
              v-if="headerAnimation === true"
            >
              <md-button
                class="md-danger md-simple fix-broken-card"
                @click="fixHeader"
                v-if="headerDown"
              >
                <md-icon>build</md-icon> Fix Header!
              </md-button>
              <!-- View -->
              <md-button
                class="md-primary md-just-icon md-round"
                :href="`https://www.vinozito.mk/blog/${blog.UrlTag}`"
                target="_blank"
              >
                <md-icon>search</md-icon>
              </md-button>
              <!-- Edit -->
              <md-button
                class="md-warning md-just-icon md-round"
                @click="editBlog(blog.Id)"
              >
                <md-icon>create</md-icon>
              </md-button>
              <!-- Delete -->
              <md-button
                class="md-danger md-just-icon md-round"
                @click="promptDeleteBlog(blog)"
              >
                <md-icon>delete_sweep</md-icon>
              </md-button>
            </div>
            <h4 class="title">
              <a href="#pablo">{{ blog.Title }}</a>
            </h4>
            <div class="card-description">
              {{ formatDate(blog.PublishDate) }}
            </div>
          </md-card-content>

          <md-card-actions md-alignment="space-between">
            <div class="stats">
              <span class="category" v-if="blog.IsActive">
                <md-icon>check_circle_outline</md-icon>
                Active
              </span>
              <span class="category" v-if="blog.IsFeatured">
                <md-icon>star_border</md-icon>
                Featured
              </span>
            </div>
          </md-card-actions>
        </md-card>
      </div>

      <modal v-if="smallAlertModal" @close="smallAlertModalHide">
        <template slot="header">
          <md-button
            class="md-simple md-just-icon md-round modal-default-button"
            @click="smallAlertModalHide"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <p>Are you sure you want to delete the blog?</p>
        </template>

        <template slot="footer">
          <md-button class="md-simple" :disabled="deleting" @click="smallAlertModalHide"
            >Never Mind</md-button
          >
          <md-button class="md-success md-simple" @click="deleteBlog()">
            <span v-if="!deleting">Yes</span>
            <md-progress-spinner v-else class="spinner" :md-diameter="20" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
          </md-button>
        </template>
      </modal>
    </div>
  </transition>
</div>
</template>

<script>
import { Pagination } from "@/components";
import axios from "axios";
import { Modal } from "@/components";
import cdnInvalidator from "@/services/cdnInvalidator";

export default {
  components: {
    Pagination,
    Modal
  },
  computed: {
    headerDown() {
      return this.hoverCount > 15;
    },
    sortBy() {
      return this.filters.sortBy;
    },
    sortOrder() {
      return this.filters.sortOrder;
    },
    status() {
      return this.filters.status;
    },
    currentPage() {
      return this.filters.currentPage;
    },
    perPage() {
      return this.filters.perPage;
    },
    to() {
      let highBound = this.from + this.filters.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.filters.perPage * (this.filters.currentPage - 1);
    },
    queriedData() {
      return this.searchedData;
    }
  },
  data() {
    return {
      total: 0,
      dataLoaded: false,
      deleting: false,
      searchTimeout: null,
      searching: false,
      hoverCount: 0,
      imgHovered: false,
      fixedHeader: false,
      headerAnimation: true,
      smallAlertModal: false,
      blogToDelete: null,
      months: ["Јан", "Фев", "Мар", "Апр", "Мај", "Јун", "Јул", "Авг", "Сеп", "Окт","Ное", "Дек"],
      filters: {
        sortBy: "createdAt",
        sortOrder: "desc",
        perPage: 16,
        currentPage: 1,
        status: "all"
      },
      perPageOptions: [4, 8, 16, 32, 64],
      searchQuery: "",
      searchedData: []
    };
  },
  methods: {
    formatDate (date) {
      if(!date) {
        return ''
      }
      date = new Date(date);
      return `${date.getDate()} ${this.months[date.getMonth()]} ${date.getFullYear()}`;
    },
    openNewBlogForm() {
      this.$router.push({ name: "EditBlog", params: { id: 0 } });
    },
    searchBlogs () {
      this.searching = true
      this.filters.filter = this.searchQuery && this.searchQuery.length ? this.searchQuery : null;
      
      let promise1 = this.queryBlogs();
      let promise2 = this.queryTotalCount();
      
      Promise.all([promise1, promise2]).finally(() => {
        this.searching = false
      })
    },
    deleteBlog() {
      this.deleting = true
      axios
        .delete(`api/Blog/${this.blogToDelete.Id}`)
        .then(() => {
          cdnInvalidator.onBlogDeleteOrUpdate(this.blogToDelete)
          
          this.searchBlogs();
          this.$notify({
            message: "The blog was successfully deleted",
            icon: "check_circle_outline",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "success"
          });
        })
        .catch(errors => {
          errors.forEach(error => {
            this.$notify({
              message: error,
              icon: "error_outline",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger"
            });
          });
        })
        .finally(() => {
          this.blogToDelete = null;
          this.smallAlertModal = false;
          this.deleting = false
        });
    },
    smallAlertModalHide: function() {
      this.smallAlertModal = false;
      this.blogToDelete = null;
    },
    queryBlogs() {
      return axios
        .get("api/Blog", {
          params: this.filters
        })
        .then(response => {
          this.searchedData = response.data;
          this.dataLoaded = true;
        });
    },
    queryTotalCount() {
      return axios
        .get("api/Blog/Count", {
          params: this.filters
        })
        .then(response => {
          this.total = response.data;
        });
    },
    editBlog(blogId) {
      this.$router.push({ name: "EditBlog", params: { id: blogId } });
    },
    promptDeleteBlog(blog) {
      this.smallAlertModal = true;
      this.blogToDelete = blog;
    },
    headerBack: function() {
      this.fixedHeader = false;
    },
    fixHeader: function() {
      this.hoverCount = 0;
      this.fixedHeader = true;

      setTimeout(this.headerBack, 480);
    },
    onMouseOver: function() {
      if (this.headerAnimation === "true") {
        this.imgHovered = true;
        this.hoverCount++;
      }
    },
    onMouseLeave: function() {
      if (this.headerAnimation === "true") {
        this.imgHovered = false;
      }
    }
  },
  mounted() {
    this.searchBlogs();
  },
  watch: {
    searchQuery() {
      if (this.searchTimeout)
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.searchBlogs();
      }, 500);
    },
    sortBy() {
      this.searchBlogs();
    },
    sortOrder() {
      this.searchBlogs();
    },
    status() {
      this.searchBlogs();
    },
    currentPage() {
      this.searchBlogs();
    },
    perPage() {
      this.searchBlogs();
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions{
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.md-table .md-table-head.th:nth-child(3),
.md-table .md-table-head.th:nth-child(4){
  min-width: 180px;
}
.md-table .md-table-head.th:nth-child(7) {
  min-width: 200px;
}
.subject{
  font-weight: 400;
}
.md-card-testimonial .avatar {
  box-shadow: 0 0px 10px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow:  0 0px 10px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
}
.description{
    white-space: pre-line;
}
.card-icon {
  margin-top: 0 !important;
  float: right !important;
  margin-right: 0 !important;
}
.mt-10 {
  margin-top: 10px;
}
</style>
